import { createSignal, onCleanup, onMount } from 'solid-js';
import ProfileSettingsModal from './ProfileSettingsModal';
import HowToModal from './HowToModal';
import ProvablyFairModal from './ProvablyFairModal';
import ToastNotification from '../ui/ToastNotification';

export default function ModalManager() {
  const [profileOpen, setProfileOpen] = createSignal(false);
  const [howtoOpen, setHowtoOpen] = createSignal(false);
  const [fairOpen, setFairOpen] = createSignal(false);

  const closeAll = () => { setProfileOpen(false); setHowtoOpen(false); setFairOpen(false); };

  const hookOpenModal = () => {
    const w = window as any;
    const original = w.openModal;
    w.openModal = (id: string) => {
      if (id === 'profile') { closeAll(); setProfileOpen(true); return true; }
      if (id === 'how-to') { closeAll(); setHowtoOpen(true); return true; }
      if (id === 'provably-fair') { closeAll(); setFairOpen(true); return true; }
      return typeof original === 'function' ? original(id) : false;
    };
    (w as any).__solidModalWrapped = true;
  };

  onMount(() => {
    const onReady = () => hookOpenModal();
    if ((window as any).memePumpApp) hookOpenModal();
    window.addEventListener('memePump:ready' as any, onReady, { once: true });
    onCleanup(() => window.removeEventListener('memePump:ready' as any, onReady));
  });

  return (
    <>
      <ToastNotification />
      <ProfileSettingsModal open={profileOpen()} onClose={() => setProfileOpen(false)} />
      <HowToModal open={howtoOpen()} onClose={() => setHowtoOpen(false)} />
      <ProvablyFairModal open={fairOpen()} onClose={() => setFairOpen(false)} />
    </>
  );
}
